<template>
	<div class="commission-details my-account" ref="container">
		<div class="wrapper">
			<div class="header">
				<div class="headerCon">
					<div class="account acea-row row-top row-between">
						<div class="assets">
							<div>我的金币</div>
							<div class="money">{{ userInfo.brokerage_price || 0 }}</div>
						</div>
						<div>
							<router-link :to="'/user/user_cash2'" class="recharge font-color-green">提现</router-link>
						</div>
						
					</div>
					<div class="cumulative acea-row row-top">
						
						<div class="item">
							<div>1金币=1元</div>
						</div>
					</div>
				</div>
			</div>
			<div class="sign-record" ref="content">
				<div class="list">
					<div class="item" v-for="(item, index) in info" :key="index">
						<!-- <div class="data">{{ item.time }}</div> -->
						<div class="listn" v-for="(val, indexn) in item.list" :key="indexn" style="padding: 0 0.2rem;">
							<div class="itemn acea-row row-between-wrapper">
								<div>
									<div class="name line1">{{ val.title }}</div>
									<div>{{ val.add_time }}</div>
								</div>
								<div class="num" v-if="val.pm == 1">+{{ val.number }}</div>
								<div class="num font-color-red" v-if="val.pm == 0">
									-{{ val.number }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="noCart" v-if="info.length === 0 && where.page > 1">
				<div class="pictrue"><img src="@assets/images/noList.png" /></div>
			</div>
		</div>
		
		<Loading :loaded="loaded" :loading="loading"></Loading>
	</div>
</template>
<script>
	import {
		getCommissionInfo,
		getSpreadInfo,
		getUser
	} from "@api/user";
	import Loading from "@components/Loading";
	const NAME = "CommissionDetails";
	export default {
		name: NAME,
		components: {
			Loading
		},
		props: {},
		data: function() {
			return {
				info: [],
				commission: 0,
				where: {
					page: 1,
					limit: 10
				},
				types: 3,
				loaded: false,
				loading: false,
				userInfo:{}
			};
		},
		mounted: function() {
			this.getCommission();
			this.User();
			this.getIndex();
			this.$scroll(this.$refs.container, () => {
				this.loading === false && this.getIndex();
			});
			console.log(this.info)
		},
		actived(){
			console.log("111")
		},
		methods: {
			User: function() {
				let that = this;
				getUser().then(res => {
					that.userInfo = res.data;
					that.orderStatusNum = res.data.orderStatusNum;
					this.generalContent = {
						promoterNum: `您在商城累计消费金额仅差 <span style="color: #ff8500;">${res
			.data.promoter_price || 0}元</span>即可开通推广权限`,
						title: "您未获得推广权限"
					};
				});
			},
			getIndex: function() {
				let that = this;
				if (that.loading == true || that.loaded == true) return;
				that.loading = true;
				getCommissionInfo(that.where, that.types).then(
					res => {
						that.loading = false;
						that.loaded = res.data.length < that.where.limit;
						that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
						that.where.page = that.where.page + 1;
						that.info.push.apply(that.info, res.data);
					},
					error => {
						that.$dialog.message(error.msg);
					}
				);
			},
			getCommission: function() {
				let that = this;
				getSpreadInfo().then(
					res => {
						that.commission = res.data.commissionCount;
					},
					error => {
						this.$dialog.message(error.msg);
					}
				);
			}
		}
	};
</script>
<style scoped>
	.noCart {
		margin-top: 0.17rem;
		padding-top: 0.1rem;
	}

	.noCart .pictrue {
		width: 4rem;
		height: 3rem;
		margin: 0.7rem auto 0.5rem auto;
	}

	.noCart .pictrue img {
		width: 100%;
		height: 100%;
	}
	/* .recharge{
		font-size: .28rem;
		width: 1.5rem;
		height: .54rem;
		border-radius: .27rem;
		text-align: center;
		line-height: .54rem;
		display: block;
		margin-bottom: .2rem;
		background: #ed1c2c;
		color: #fff;
	} */
</style>
